import PageLayoutContainer from './container'
export default PageLayoutContainer
